import logo from '../assets/rheintec.svg';
import React from 'react';

function TopBar() {
    return (
        <div className="w-100 pt-3 ps-4 pb-3 border-bottom border-light ">
            <img src={logo} className='logo' alt="logo" />
        </div>
    );
}

export default TopBar;
